// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"80b8a5ea","41":"80b8a5ea","269":"80b8a5ea","904":"80b8a5ea"}[chunkId] + ".chunk.css";
};